export default "__VITE_ASSET__44b90967__"